import { Factory } from 'fishery';
import { Attachment } from '@trukt/types/Attachment';

export const attachmentFactory = Factory.define<Attachment>(({ sequence }) => ({
  guid: sequence.toString(),
  name: 'EBOL',
  status: 'uploaded',
  totalBytes: 0,
  fileLocation:
    'https://rcgfilestorage.blob.core.windows.net/documents-staging/jobs/a570e431-fd09-4af7-8bee-6c4e92924fd6/454334fe-040e-44c3-825f-ad922b0920b3/ebol.txt',
  dateCreated: '2023-01-20T22:32:24.981Z',
  createdById: '3e05c153-9dcd-49df-8efc-e777ae668f6f',
  acl: 'company',
  usage: 'Bill Of Lading',
  type: 'vendorInvoice',
  url: 'https://rcgfilestorage.blob.core.windows.net/documents-staging/jobs/a570e431-fd09-4af7-8bee-6c4e92924fd6/454334fe-040e-44c3-825f-ad922b0920b3/pipelineLog-{37b468fb-95b3-406d-a26f-861bf3522e7c} (1).txt',
  extension: 'text/plain',
  parent: 'a570e431-fd09-4af7-8bee-6c4e92924fd6',
  parentTable: 'jobs',
  visibility: ['internal'],
  dateUpdated: null,
  createdByGuid: '3e05c153-9dcd-49df-8efc-e777ae668f6f',
  updatedByGuid: null,
}));
